export default "__VITE_ASSET__BBOdneCA__"